import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable, map, of, tap } from 'rxjs';
import { LaudatioGQL} from 'src/generated/graphql';
import { completeData } from '@app/_helpers/apollo';

@Component({
    selector: 'app-laudatio',
    templateUrl: './laudatio.component.html',
    styleUrls: ['./laudatio.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LaudatioComponent implements OnInit {

  laudatio$: Observable<any> = of();
  constructor(private laudatioGql: LaudatioGQL) { }

  ngOnInit(): void {
    this.laudatio$ = this.laudatioGql.watch().valueChanges.pipe(
      completeData(),
      map(response => {
        return (response.data.laudatio)
      })
    )
  }
}
